import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import AppStarLogo from "../images/appstar_title.jpg";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link } from "react-router-dom";

const theme = createTheme();

export const SuccessRegister = ({ email, fullName }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f8f8ff",
          padding: 2,
        }}
      >
        <Container component="main" maxWidth="md">
          <Paper
            elevation={3}
            sx={{
              padding: { xs: 3, sm: 4, md: 5 },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "white",
              borderRadius: 2,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "33.33%",
                minWidth: "200px",
                marginBottom: 2,
              }}
            >
              <img
                src={AppStarLogo}
                alt="AppStar Logo"
                style={{ width: "100%", height: "auto" }}
              />
            </Box>

            <Typography
              component="h1"
              variant="h4"
              sx={{
                color: "#1976d2",
                fontWeight: 600,
                marginBottom: 2,
                textAlign: "center",
              }}
            >
              Registration Successful!
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "#4caf50",
                marginBottom: 2,
                textAlign: "center",
              }}
            >
              Please check your email to activate your AppStar account
            </Typography>

            <Box
              sx={{
                textAlign: "center",
                color: "#666",
                marginBottom: 1,
              }}
            >
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                Hello <strong>{fullName}</strong>,
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 2 }}>
                A verification email has been sent to: <strong>{email}</strong>
              </Typography>
              <Typography variant="body2" sx={{ marginBottom: 1 }}>
                Please check your email and click on the verification link to activate your
                AppStar account.
              </Typography>
              <Typography variant="body2" sx={{ marginBottom: 2 }}>
                <em>Note: The verification email may be placed in your spam folder if you haven't 
                received emails from us before.</em>
              </Typography>
            </Box>

            <Typography variant="body1" sx={{ color: "#1976d2", fontWeight: 500 }}>
              Once activated, please{" "}
              <Link to="/login" style={{ color: "#1976d2", fontWeight: 600 }}>
                log in to AppStar
              </Link>
            </Typography>
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
};
